import { render, staticRenderFns } from "./AssignmentLibraryDetail.vue?vue&type=template&id=50c8dd44&scoped=true&"
import script from "./AssignmentLibraryDetail.vue?vue&type=script&lang=js&"
export * from "./AssignmentLibraryDetail.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentLibraryDetail.vue?vue&type=style&index=0&id=50c8dd44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c8dd44",
  null
  
)

export default component.exports